// src/views/AboutPage.jsx - VERSION DYNAMIQUE AVEC API (affichage HTML direct)
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PublicTopBar from "./PublicTopBar";
import Footer from "../components/Footer";
import { publicSiteWebService } from "../services/publicSiteWebService";

export default function AboutPage() {
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({ parametres: null, contact: null });
  const [htmlContent, setHtmlContent] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const [publicData, aboutDoc] = await Promise.all([
          publicSiteWebService.getPublicData(),
          publicSiteWebService.getDocumentLegal("apropos").catch(() => null),
        ]);
        
        setPageData({
          parametres: publicData?.parametres || null,
          contact: publicData?.contact || null,
        });
        
        // Utiliser le contenu HTML directement
        if (aboutDoc?.contenu) {
          setHtmlContent(aboutDoc.contenu);
        } else {
          setHtmlContent(null);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const params = pageData.parametres || {};
  const contact = pageData.contact || {};
  const nomEditeur = params.nom_editeur || "Enumera";
  const email = contact.email || "contact@enumera.com";

  if (loading) {
    return (
      <div className="about-page">
        <PublicTopBar />
        <div className="loader-container">
          <div className="loader-spinner" />
        </div>
        <Footer />
        <style>{`
          .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }
          .loader-spinner { width: 48px; height: 48px; border: 4px solid #e2e8f0; border-top-color: #004080; border-radius: 50%; animation: spin 0.8s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  return (
    <>
      <style>{`
        :root {
          --n-bg: #f8f9fa;
          --n-card: #ffffff;
          --n-ink: #0f1b2d;
          --n-mut: #64748b;
          --n-b: #e8e8ee;
          --n-b2: #d0d0da;
          --pr: #004080;
          --pr-lt: #0066CC;
          --pr-bg: #e6eef7;
        }

        .about-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: var(--n-bg);
        }

        .about-hero {
          flex: 1;
          padding: 120px 20px 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .about-content {
          max-width: 960px;
          width: 100%;
          animation: fadeInUp 0.6s ease;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .about-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .about-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: var(--pr-bg);
          color: var(--pr);
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .about-badge i { font-size: 17px; }

        .about-title {
          font-size: 38px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 8px;
          line-height: 1.2;
        }

        .about-title span { color: var(--pr); }

        .about-meta {
          font-size: 15px;
          line-height: 1.6;
          color: var(--n-mut);
          max-width: 620px;
          margin: 0 auto 20px;
        }

        .about-divider {
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, var(--pr), var(--pr-lt));
          border-radius: 2px;
          margin: 0 auto 20px;
        }

        .about-body {
          background: var(--n-card);
          border: 1px solid var(--n-b);
          border-radius: 16px;
          padding: 40px 48px;
          margin-bottom: 24px;
          box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        }

        .about-body h1 {
          font-size: 28px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 0 0 16px;
        }

        .about-body h2 {
          font-size: 22px;
          font-weight: 700;
          color: var(--n-ink);
          margin: 28px 0 12px;
          padding-bottom: 8px;
          border-bottom: 2px solid var(--pr-bg);
        }

        .about-body h3 {
          font-size: 18px;
          font-weight: 600;
          color: var(--n-ink);
          margin: 20px 0 10px;
        }

        .about-body h4 {
          font-size: 16px;
          font-weight: 600;
          color: var(--n-ink);
          margin: 16px 0 8px;
        }

        .about-body p {
          font-size: 15px;
          line-height: 1.8;
          color: var(--n-ink);
          margin: 0 0 12px;
        }

        .about-body ul {
          padding-left: 24px;
          margin: 8px 0 16px;
        }

        .about-body li {
          font-size: 15px;
          line-height: 1.7;
          color: var(--n-ink);
          margin-bottom: 6px;
        }

        .about-body strong {
          color: var(--pr);
        }

        .about-body hr {
          margin: 24px 0;
          border: none;
          border-top: 1px solid var(--n-b);
        }

        .about-empty {
          text-align: center;
          padding: 60px 20px;
          color: var(--n-mut);
          font-size: 15px;
        }

        .about-empty i {
          font-size: 32px;
          display: block;
          margin-bottom: 8px;
        }

        .about-actions {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-wrap: wrap;
        }

        .about-cta {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: var(--pr);
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px 28px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .about-cta:hover {
          background: var(--pr-lt);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0, 64, 128, 0.3);
        }

        .about-cta i { font-size: 17px; }

        .about-cta-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          color: var(--pr);
          border: 2px solid var(--pr);
          border-radius: 12px;
          padding: 12px 26px;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .about-cta-secondary:hover {
          background: var(--pr);
          color: #fff;
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(0,64,128,0.15);
        }

        .loader-container { min-height: 60vh; display: flex; justify-content: center; align-items: center; }

        .loader-spinner {
          width: 48px;
          height: 48px;
          border: 4px solid #e2e8f0;
          border-top-color: #004080;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @media (max-width: 768px) {
          .about-title { font-size: 30px; }
          .about-hero { padding: 100px 16px 30px; }
          .about-body { padding: 24px 20px; }
        }

        @media (max-width: 480px) {
          .about-title { font-size: 24px; }
          .about-hero { padding: 90px 16px 20px; }
          .about-body { padding: 16px; }
          .about-body h1 { font-size: 22px; }
          .about-body h2 { font-size: 18px; }
          .about-body p, .about-body li { font-size: 14px; }
          .about-cta, .about-cta-secondary { width: 100%; justify-content: center; }
        }
      `}</style>

      <div className="about-page">
        <PublicTopBar />

        <section className="about-hero">
          <div className="about-content">
            <div className="about-header">
              <div className="about-badge">
                <i className="ti ti-info-circle"></i>
                <span>À propos</span>
              </div>

              <h1 className="about-title">
                Qui est <span>{nomEditeur}</span> ?
              </h1>

              <div className="about-divider"></div>
            </div>

            <div className="about-body">
              {htmlContent ? (
                <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
              ) : (
                <div className="about-empty">
                  <i className="ti ti-file-off"></i>
                  Le contenu de cette page n'est pas encore disponible.
                </div>
              )}
            </div>

            <div className="about-actions">
              <Link to="/" className="about-cta">
                <i className="ti ti-arrow-left" aria-hidden="true"></i>
                Retour à l'accueil
              </Link>
              <a href={`mailto:${email}`} className="about-cta-secondary">
                <i className="ti ti-mail"></i>
                Nous contacter
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}